import { Link } from "react-router-dom";
import {
    Briefcase,
    Brain,
    Apple,
    Flower2,
    MessageSquare,
    ClipboardList,
    ArrowRight,
} from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [Briefcase, Brain, Apple, Flower2, MessageSquare, ClipboardList];

const MethodsPreview = () => {
    const { t } = useLanguage();
    const P = t.previews.methods;
    const items = t.methods.items;

    return (
        <section
            id="methods-preview"
            data-testid="methods-preview-section"
            className="py-24 md:py-28 bg-gradient-to-b from-ella-sand to-ella-cream"
        >
            <div className="ella-container">
                <div className="grid lg:grid-cols-12 gap-12 items-end">
                    <div className="lg:col-span-6">
                        <span className="ella-overline" data-testid="methods-preview-overline">
                            {P.overline}
                        </span>
                        <h2
                            className="ella-headline text-4xl md:text-5xl mt-4 text-ella-ink"
                            data-testid="methods-preview-title"
                        >
                            {P.title}
                        </h2>
                        <p className="mt-5 text-ella-ink/70 font-light text-base leading-relaxed max-w-md">
                            {P.lead}
                        </p>
                        <Link
                            to="/methodik"
                            data-testid="methods-preview-cta"
                            className="inline-flex items-center gap-3 mt-7 group text-ella-ink hover:text-ella-gold-dark transition-colors"
                        >
                            <span className="ella-overline border-b border-ella-ink group-hover:border-ella-gold-dark pb-1 transition-colors">
                                {P.cta}
                            </span>
                            <ArrowRight
                                className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                                strokeWidth={1.5}
                            />
                        </Link>
                    </div>

                    <div className="lg:col-span-6">
                        <ul className="grid grid-cols-2 gap-px bg-ella-line rounded-2xl overflow-hidden border border-ella-line">
                            {items.map((item, i) => {
                                const Icon = ICONS[i % ICONS.length];
                                return (
                                    <li
                                        key={i}
                                        data-testid={`methods-preview-pill-${i}`}
                                        className="bg-white p-5 flex items-center gap-3"
                                    >
                                        <span className="w-9 h-9 rounded-xl bg-ella-ink flex items-center justify-center text-ella-gold flex-shrink-0">
                                            <Icon className="w-4 h-4" strokeWidth={1.4} />
                                        </span>
                                        <span className="text-sm text-ella-ink leading-tight">
                                            {item.title}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MethodsPreview;
